export enum ENotificationReason {
  ASSIGNED = 'assigned',
  CREATED = 'created',
  OTHER = 'other',
}
